import React from 'react'
import { Logo } from '../../assets/svg'

const BrandLogo: React.FC = () => {
    return (
        <div className="brand-logo">
            <a className="logo">
                <img src={Logo} alt="Logo" />
            </a>
        </div>
    )
}
export default BrandLogo
